/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSON, UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataToJSON } from './UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseData';
export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseFromJSON(json) {
    return UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseFromJSONTyped(json, false);
}
export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: json['status'],
        data: UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataFromJSON(json['data'])
    };
}
export function UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: UserV1OrganizationPaymentBillingInfoRetrievePaymentMethodPaymentMethodIdGet200ResponseDataToJSON(value.data)
    };
}
